export const actionTypes = {
    //TODO: If we go for this, then at least lets split it up
    // lets not have everything in "actionTypes"

    //PublicationLogStore Actions
    DELETE_PUBLICATION: "DELETE_PUBLICATION",
    DELETE_PUBLICATION_SUCCESS: "DELETE_PUBLICATION_SUCCESS",
    DELETE_PUBLICATION_FAIL: "DELETE_PUBLICATION_FAIL",
    PUBLICATION_LOG_CLEAR_ERROR: "PUBLICATION_LOG_CLEAR_ERROR",
    GET_PUBLICATION_LOG: "GET_PUBLICATION_LOG",
    GET_PUBLICATION_LOG_SUCCESS: "GET_PUBLICATION_LOG_SUCCESS",
    GET_PUBLICATION_LOG_FAIL: "GET_PUBLICATION_LOG_FAIL",

    //PublicationStore Actions
    NEW_PUBLICATION: "NEW_PUBLICATION",
    NEW_PUBLICATION_SUCCESS: "NEW_PUBLICATION_SUCCESS",
    NEW_PUBLICATION_FAIL: "NEW_PUBLICATION_FAIL",
    ADD_PUBLICATION: "ADD_PUBLICATION",
    ADD_PUBLICATION_SUCCESS: "ADD_PUBLICATION_SUCCESS",
    ADD_PUBLICATION_FAIL: "ADD_PUBLICATION_FAIL",
    UPDATE_PUBLICATION: "UPDATE_PUBLICATION",
    UPDATE_PUBLICATION_SUCCESS: "UPDATE_PUBLICATION_SUCCESS",
    UPDATE_PUBLICATION_FAIL: "UPDATE_PUBLICATION_FAIL",
    PUBLICATION_CLEAR_ERROR: "PUBLICATION_CLEAR_ERROR",
    GET_PUBLICATION: "GET_PUBLICATION",
    GET_PUBLICATION_SUCCESS: "GET_PUBLICATION_SUCCESS",
    GET_PUBLICATION_FAIL: "GET_PUBLICATION_FAIL",

    //Smpac Header Actions
    GET_SMPAC_HEADER: "GET_SMPAC_HEADER",
    GET_SMPAC_HEADER_SUCCESS: "GET_SMPAC_HEADER_SUCCESS",

    //PublicationRights Actions
    PUBLICATION_RIGHTS_CLEAR_ERROR: "PUBLICATION_RIGHTS_CLEAR_ERROR",
    GET_PUBLICATION_RIGHTS: "GET_PUBLICATION_RIGHTS",
    GET_PUBLICATION_RIGHTS_SUCCESS: "GET_PUBLICATION_RIGHTS_SUCCESS",
    GET_PUBLICATION_RIGHTS_FAIL: "GET_PUBLICATION_RIGHTS_FAIL",
    UPDATE_PUBLICATION_RIGHT: "UPDATE_PUBLICATION_GLOBAL",
    UPDATE_PUBLICATION_RIGHT_SUCCESS: "UPDATE_PUBLICATION_RIGHT_SUCCESS",
    UPDATE_PUBLICATION_RIGHT_FAIL: "UPDATE_PUBLICATION_RIGHT_FAIL",

    //ProgrammeCategory Actions
    PROGRAMME_CATEGORY_CLEAR_ERROR: "PROGRAMME_CATEGORY_CLEAR_ERROR",
    GET_PROGRAMME_CATEGORY: "GET_PROGRAMME_CATEGORY",
    GET_PROGRAMME_CATEGORY_SUCCESS: "GET_PROGRAMME_CATEGORY_SUCCESS",
    GET_PROGRAMME_CATEGORY_FAIL: "GET_PROGRAMME_CATEGORY_FAIL",
    UPDATE_PROGRAMME_CATEGORY: "UPDATE_PUBLICATION_GLOBAL",
    UPDATE_PROGRAMME_CATEGORY_SUCCESS: "UPDATE_PROGRAMME_CATEGORY_SUCCESS",
    UPDATE_PROGRAMME_CATEGORY_FAIL: "UPDATE_PROGRAMME_CATEGORY_FAIL",

    //DeletedCuesStore Actions
    DELETED_CUES_CLEAR_ERROR: "DELETED_CUES_CLEAR_ERROR",
    GET_DELETED_CUES: "GET_DELETED_CUES",
    GET_DELETED_CUES_SUCCESS: "GET_DELETED_CUES_SUCCESS",
    GET_DELETED_CUES_FAIL: "GET_DELETED_CUES_FAIL",

    //NonLinearFormStore Actions
    MODE_CLEAR_ERROR: "MODE_CLEAR_ERROR",
    GET_MODE: "GET_MODE",
    GET_MODE_SUCCESS: "GET_MODE_SUCCESS",
    GET_MODE_FAIL: "GET_MODE_FAIL",
    GET_PLATFORMS: "GET_PLATFORMS",
    GET_PLATFORMS_SUCCESS: "GET_PLATFORMS_SUCCESS",
    GET_PLATFORMS_FAIL: "GET_PLATFORMS_FAIL",

    //NonLinearStore Actions
    GET_NL_CAN_EDIT: "GET_NL_CAN_EDIT",
    GET_NL_CAN_EDIT_SUCCESS: "GET_NL_CAN_EDIT_SUCCESS",
    GET_NL_CAN_EDIT_FAIL: "GET_NL_CAN_EDIT_FAIL",
    GET_NL_VALIDATION: "GET_NL_VALIDATION",
    GET_NL_VALIDATION_SUCCESS: "GET_NL_VALIDATION_SUCCESS",
    GET_NL_VALIDATION_FAIL: "GET_NL_VALIDATION_FAIL",
    UPDATE_NL_VALIDATION: "UPDATE_NL_VALIDATION",
    UPDATE_NL_VALIDATION_SUCCESS: "UPDATE_NL_VALIDATION_SUCCESS",
    UPDATE_NL_VALIDATION_FAIL: "UPDATE_NL_VALIDATION_FAIL",
    UPDATE_NL_VALIDATION_MESSAGE: "UPDATE_NL_VALIDATION_MESSAGE",

    //CueHistoryStore Actions
    CUE_HISTORY_CLEAR_ERROR: "CUE_HISTORY_CLEAR_ERROR",
    GET_CUE_HISTORY: "GET_CUE_HISTORY",
    GET_CUE_HISTORY_SUCCESS: "GET_CUE_HISTORY_SUCCESS",
    GET_CUE_HISTORY_FAIL: "GET_CUE_HISTORY_FAIL",

    //AmendmentHistoryStore Actions
    AMENDMENT_HISTORY_CLEAR_ERROR: "AMENDMENT_HISTORY_CLEAR_ERROR",
    GET_AMENDMENT_HISTORY: "GET_AMENDMENT_HISTORY",
    GET_AMENDMENT_HISTORY_SUCCESS: "GET_AMENDMENT_HISTORY_SUCCESS",
    GET_AMENDMENT_HISTORY_FAIL: "GET_AMENDMENT_HISTORY_FAIL",

    // #region Auth
    PURGE: "PURGE",
    LOGIN: "LOGIN",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",
    LOGIN_FAIL: "LOGIN_FAIL",
    VERIFY_EMAIL: "VERIFY_EMAIL",
    VERIFY_EMAIL_SUCCESS: "VERIFY_EMAIL_SUCCESS",
    VERIFY_EMAIL_GATEWAY: "VERIFY_EMAIL_GATEWAY",
    VERIFY_EMAIL_STATUS_SUCCESS: "VERIFY_EMAIL_STATUS_SUCCESS",
    VERIFY_EMAIL_LINK_SUCCESS: "VERIFY_EMAIL_LINK_SUCCESS",
    VERIFY_EMAIL_FAIL: "VERIFY_EMAIL_FAIL",
    VERIFY_2FA: "VERIFY_2FA",
    GET_2FA_SUCCESS: "GET_2FA_SUCCESS",
    SEND_2FA: "SEND_2FA",
    SEND_2FA_SUCCESS: "SEND_2FA_SUCCESS",
    ENABLE_RESEND_2FA_SUCCESS: "ENABLE_RESEND_2FA_SUCCESS",
    DISABLE_RESEND_2FA_SUCCESS: "DISABLE_RESEND_2FA_SUCCESS",
    SKIP_2FA_SUCCESS: "SKIP_2FA_SUCCESS",
    VERIFY_MOBILE: "VERIFY_MOBILE",
    VERIFY_MOBILE_SUCCESS: "VERIFY_MOBILE_SUCCESS",
    VERIFY_2FA_SUCCESS: "VERIFY_2FA_SUCCESS",
    VERIFY_2FA_INTRODUCING_SUCCESS: "VERIFY_2FA_INTRODUCING_SUCCESS",
    VERIFY_2FA_FAIL: "VERIFY_2FA_FAIL",
    GET_GATEWAY: "GET_GATEWAY",
    GET_GATEWAY_SUCCESS: "GET_GATEWAY_SUCCESS",
    GET_GATEWAY_FAIL: "GET_GATEWAY_FAIL"
    // #endregion
};

export const userProfileAction = {
    reload: "USER_PROFILE_RELOAD",
    getUserProfile: "GET_USER_PROFILE",
    updateMobilePhone: "UPDATE_USER_MOBILE_PHONE",
    validateMobilePhone: "VERIFY_USER_MOBILE_PHONE",
    failed: "USER_PROFILE_FAILURE",
    beforeSendingRequest: "USER_PROFILE_BEFORE_REQUEST",
    resendMobileVerificationCode: "RESEND_USER_MOBILE_VERIFICATION"
};


// WEBPACK FOOTER //
// ./src/actionTypes.js